module.exports = __webpack_public_path__ + "img/Walter.1c8d3561.jpg";